<template>
  <FiltersItem>
    <template #title>
      {{ l('filters.baggage.chipName') }}
    </template>
    <template #content>
      <FiltersItemContent class="filterBaggage--inner">
        <template #content>
          <button
            v-for="(item, i) in products"
            :key="i"
            class="abBtnCard"
            :class="{ 'active': item.isChecked, 'locked': item.isLocked }"
            @click="productToggle(item)"
          >
            <img
              :src="item.image"
              loading="lazy"
            >
            <div class="abBtnCard__side">
              <span class="abBtnCard__deal">{{ item.text }}</span>
              <span class="abBtnCard__text">{{ item.textDescription }}</span>
            </div>
          </button>
        </template>
      </FiltersItemContent>
    </template>

    <template #summary>
      <FiltersItemSummary :items="summaryItems" />
    </template>
  </FiltersItem>
</template>

<script setup>
import { l, lreplace } from '@utils/toolbox';

import { useFiltersStore } from './store/filtersStore';

const filtersStore = useFiltersStore();

const summaryItems = computed(() => {
	const summary = [];
	if (filtersStore.state.baggageIncluded) {
		summary.push(lreplace('showresult.filter.summary.baggageIncluded', { included: '<span>' + l('global.simplePhrases.included') + '</span>' }));
	}

	if (filtersStore.state.cabinBaggageIncluded) {
		summary.push(lreplace('showresult.filter.summary.cabinBaggageIncluded', { included: '<span>' + l('global.simplePhrases.included') + '</span>' }));
	}

	return summary;
});

const products = computed(() => {
	return [
		{
			text: l('filters.baggage.underSeatTitle'),
			key: 'underSeat',
			textDescription: l('filters.baggage.underSeatDescription'),
			value: 1,
			image: '/assets/images/global/icon-vaskor.svg',
			isChecked: true,
			isLocked: true,
			enabledValue: js_params.passengers - js_params.infants
		},
		{
			text: l('global.simplePhrases.cabinBaggageIncluded'),
			value: 1,
			key: 'cabinBaggageIncluded',
			textDescription: l('filters.baggage.cabinBaggageDescription'),
			image: '/assets/images/global/icon-cabinBaggageIncluded.svg',
			tooltipIcon: 'info',
			isChecked: filtersStore.state.cabinBaggageIncluded,
			enabledValue: js_params.passengers - js_params.infants
		},
		{
			text: l('global.simplePhrases.baggageIncluded'),
			key: 'baggageIncluded',
			textDescription: l('filters.baggage.checkInBaggageDescription'),
			value: 1,
			image: '/assets/images/global/icon-baggageIncluded.svg',
			isChecked: filtersStore.state.baggageIncluded,
			enabledValue: js_params.passengers - js_params.infants
		}
	];
});

async function productToggle (event) {
	// If backpack remove all baggage filters
	if (event.key === 'underSeat') {
		return;
	}
	const { key, enabledValue } = event;
	const value = filtersStore.state[key] ? null : enabledValue;
	await filtersStore.set({ key, value });
}
</script>

<style lang="scss" scoped>
img {
    margin-left: 0.2rem;
    aspect-ratio: 1/1;

    @include breakpoint_up(md) {
        height: 3.2rem;
        margin-top: 0.1rem;
        display: block;
    }
}

.filterBaggage--inner {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	padding: 0;
	gap: 1rem;

	.abBtnCard {
		height: auto;
		gap: .5rem;
		flex-direction: row;
		padding: 1rem;

		&.active {
			background-color: $color-blue-000;
			border-top: .3rem solid transparent;
			border-bottom: .3rem solid $color-blue-400;

			&.locked {
				// height: 6rem;
				border: none;
				opacity: .7;

				.abBtnCard__side {
					gap: .2rem;
				}

				.abBtnCard__deal {
					font-size: 1.3rem;
				}

				.abBtnCard__text {
					font-size: 1.1rem;
				}

				img {
					@include breakpoint_down(md) {
						width: 30%;
					}
				}
			}
		}

		img {
			max-width: 8rem;

			@include breakpoint_between(md,lg) {
				height: 8rem;
			}
		}
	}

	.abBtnCard__side {
		text-align: left;
		display: flex;
		flex-direction: column;
		gap: .5rem;
		color: $black;
		width: 70%;
		// padding-bottom: 15px;
		// padding-top: 10px;


		.abBtnCard__text {
			height: auto;
			font-size: 1.4rem;
			line-height: 1.6rem;
			font-weight: 400;

			@include breakpoint_between(md,lg) {
				line-height: 1.6rem;
				font-size: 1.2rem;
			}
		}
	}

	.abBtnCard__deal {
		height: auto;
		font-size: 1.6rem;
	}

	.abBtnCard__text {
		max-width: 90%;
		// height: 2.6rem;
		display: flex;
		flex-direction: column;
		justify-content: center;

		@include breakpoint_between(md, lg) {
			height: auto;
		}
	}

	.abBtnCard__deal {
		font-size: 2rem;
		height: 3.2rem;
		display: flex;
		flex-direction: column;
		justify-content: center;
		font-weight: bold;

		@include breakpoint_between(md, lg) {
			height: auto;
		}
	}
}
</style>
